// extracted by mini-css-extract-plugin
module.exports = {"topTypography":"page-module--top-typography--2-mFw","linkButton":"page-module--link-button--2LFP-"};